import api from '@/services/api';

export default {
  async fetchIcons(q: string) {
    return api.fetch(`/icons?q=${q}`, 'GET');
  },
};
